// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

window.Trello.authorize({
  type: 'redirect',
  name: 'Vostok Subjects Manager',
  scope: {
    read: 'true',
    write: 'true'
  },
  expiration: 'never',
  success: function(){
    Vue.use(BootstrapVue);

    Vue.config.productionTip = false

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  },
  error: function(){
    alert('erreur authentification trello');
  }
})






// WEBPACK FOOTER //
// ./src/main.js